import { VFC } from 'react'
import { Stack } from '@mui/material'
import { CATEGORY_FILTERS } from '../../types'
import AddFilterButton from './addFilterButton.component'
import CategoryFilter from './categoryFilter.component'

interface PerimeterFiltersProps {
    filters: { key: string; values: string[] }[]
    filterOptions: Record<string, string[]>
    addFilter: (key: string) => void
    removeFilter: (key: string) => void
    updateFilterValues: (key: string, values: string[]) => void
}

const PerimeterFilters: VFC<PerimeterFiltersProps> = ({ filters, filterOptions, ...methods }) => {
    return (
        <>
            <Stack>
                {filters.map(({ key, values }) => (
                    <CategoryFilter
                        title={key}
                        key={key}
                        values={values}
                        setValues={(newValues: string[]) => methods.updateFilterValues(key, newValues)}
                        options={filterOptions[key] || []}
                        onRemove={() => methods.removeFilter(key)}
                    />
                ))}
            </Stack>
            <AddFilterButton
                keys={CATEGORY_FILTERS}
                disabledKeys={filters.map((filter) => filter.key)}
                onAddFilter={(key: string) => methods.addFilter(key)}
            />
        </>
    )
}

export default PerimeterFilters
